const COGNITO_EXCEPTION_WORDING_MAPPER = {
  "InvalidParameter" : "errCode_20000",
  "UsernameExistsException" : "errCode_20001",
  "duplicateUserId" : "errCode_20002",
  "SpecifiedIdNotFound" : "errCode_20003",
  "InvalidToken" : "errCode_20004",
  "InvalidUser" : "error_usename_not_exist"
}

module.exports = { COGNITO_EXCEPTION_WORDING_MAPPER };